import axios from 'axios';

const BACKEND_API = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export const trackSearch = async (searchQuery, school, year, resultsCount) => {
  try {
    await axios.post(`${BACKEND_API}/analytics/search`, {
      search_query: searchQuery,
      school,
      year,
      results_count: resultsCount
    });
  } catch (error) {
    console.error('Analytics tracking error:', error);
  }
};

export const trackDownload = async (documentTitle, documentUrl, unitCode, year) => {
  try {
    await axios.post(`${BACKEND_API}/analytics/download`, {
      document_title: documentTitle,
      document_url: documentUrl,
      unit_code: unitCode,
      year
    });
  } catch (error) {
    console.error('Analytics tracking error:', error);
  }
};

export const trackMerge = async (documentsCount, fileName) => {
  try {
    await axios.post(`${BACKEND_API}/analytics/merge`, {
      documents_count: documentsCount,
      file_name: fileName
    });
  } catch (error) {
    console.error('Analytics tracking error:', error);
  }
};

export const getStats = async () => {
  try {
    const response = await axios.get(`${BACKEND_API}/analytics/stats`);
    return response.data;
  } catch (error) {
    console.error('Error fetching stats:', error);
    return null;
  }
};
